import { useContext } from 'react';
import { SolanaLiveContext } from '../context/SolanaLiveContext';

export function useSolanaLive() {
  const context = useContext(SolanaLiveContext);

  if (!context) {
    throw new Error('useSolanaLive must be used within a SolanaLiveProvider.');
  }

  return context;
}
